/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S12_HeadingInputs */

const tr_mesafeli_s12_heading = /** @type {(inputs: Mesafeli_S12_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Hizmet Seviyesi (SLA)`)
};

const en_mesafeli_s12_heading = /** @type {(inputs: Mesafeli_S12_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Service Level (SLA)`)
};

const de_mesafeli_s12_heading = /** @type {(inputs: Mesafeli_S12_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Servicelevel (SLA)`)
};

const ru_mesafeli_s12_heading = /** @type {(inputs: Mesafeli_S12_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Уровень обслуживания (SLA)`)
};

/**
* | output |
* | --- |
* | "12. Service Level (SLA)" |
*
* @param {Mesafeli_S12_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s12_heading = /** @type {((inputs?: Mesafeli_S12_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S12_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s12_heading(inputs)
	if (locale === "de") return de_mesafeli_s12_heading(inputs)
	if (locale === "ru") return ru_mesafeli_s12_heading(inputs)
	return tr_mesafeli_s12_heading(inputs)
});